export class ProgressBarController {}

export const ProgressBarComponent = {
  controller: ProgressBarController,
  controllerAs: '$ctrl',
  template: require('./progress-bar.component.html'),
  bindings: {
    percent: '<',
    text: '<',
    color: '@',
  }
};
